import { makeActionCreator } from 'app/utils/redux';
import {
  FETCHED_CURRENT_LESSON,
} from 'app/models/publishedLessonList/constants';

export const fetchedCurrentLesson =
               makeActionCreator(FETCHED_CURRENT_LESSON, 'masterID', 'currentID');
